import { UserInformation } from "../../types";

/**
 * ctaExperienceTypeId: 7
 * After selecting another Q&A Card
 * Awareness, Interest
 */
export default function ctaHandler7(
  userInformation: UserInformation | null,
  setShowingCtaETId: (data: string | null) => void,
) {
  const { trialUserSegmentation: seg } = userInformation || {};

  if (seg !== "Awareness" && seg !== "Interest") return;

  setShowingCtaETId("7");
}
